import { FC } from 'react';
import { ApplicationsQueryBuilder } from './ApplicationsQueryBuilder';
import { ApplicationsProvider } from './context/ApplicationsContext';
import { ApplicationsTable } from './ApplicationsTable';
import { UploadApplicationsModal } from './UploadApplicationsModal';
import { DeleteApplicationPopup } from './DeleteApplicationPopup';
import { DeleteApplicationProvider } from './context/DeleteApplicationContext';

export const ApplicationsView: FC = () => {
    return (
        <section className="flex flex-col gap-4 h-full">
            <ApplicationsProvider>
                <DeleteApplicationProvider>
                    <ApplicationsQueryBuilder />

                    <ApplicationsTable />

                    <DeleteApplicationPopup />
                    <UploadApplicationsModal />
                </DeleteApplicationProvider>
            </ApplicationsProvider>
        </section>
    );
};
